(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hd-enhancements"] && !Shopify.designMode) return;
  try {
    (window.hdPageReady || Promise.resolve()).then(() => {
    const SELECTOR =
      ':is(.product-media, .card-gallery, .collection-card__image, .resource-card__media, .slide__image-container) img';

    const markLoaded = (img) => img.classList.add('is-loaded');

    const track = (img) => {
      if (img.dataset.hdTracked) return;
      img.dataset.hdTracked = 'true';
      img.classList.add('hd-skeleton-target');
      if (img.complete && img.naturalWidth > 0) {
        markLoaded(img);
        return;
      }
      img.addEventListener('load', () => markLoaded(img), { once: true });
      img.addEventListener('error', () => markLoaded(img), { once: true });
    };

    const scan = (root) => {
      if (!(root instanceof Element || root instanceof Document)) return;
      if (root instanceof HTMLImageElement && root.matches(SELECTOR)) track(root);
      for (const img of root.querySelectorAll(SELECTOR)) track(img);
    };

    scan(document);

    const revealEnabled = document.documentElement.classList.contains('hd-reveal') && 'IntersectionObserver' in window;
    const SECTION_SELECTOR = '#MainContent > .shopify-section:not(:first-child), .shopify-section-group-footer-group';
    const ITEM_SELECTOR =
      '.product-grid__item, .resource-list__item, .hd-promo__item, .hd-usp__item, .hd-contact__item, .hd-story__stat, [data-hd-reveal]';

    const revealObserver = revealEnabled
      ? new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              entry.target.classList.add('is-revealed');
              revealObserver.unobserve(entry.target);
            }
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
        )
      : null;

    const prepareReveal = (root) => {
      if (!revealObserver || !(root instanceof Element || root instanceof Document)) return;
      const sections = root instanceof Element && root.matches(SECTION_SELECTOR) ? [root] : [];
      sections.push(...root.querySelectorAll(SECTION_SELECTOR));
      for (const section of sections) {
        const items = [...section.querySelectorAll(ITEM_SELECTOR)];
        const targets = items.length ? items : [section];
        targets.forEach((target, index) => {
          if (target.dataset.hdReveal === 'done') return;
          target.dataset.hdReveal = 'done';
          if (target.getBoundingClientRect().top < window.innerHeight) return;
          target.classList.add('hd-reveal-target');
          target.style.setProperty('--hd-reveal-delay', `${(index % 4) * 90}ms`);
          revealObserver.observe(target);
        });
      }
    };

    prepareReveal(document);

    // Failsafe: never leave content hidden if the observer does not fire (e.g. background tab, old browsers)
    let failsafeTimer;
    const armFailsafe = () => {
      clearTimeout(failsafeTimer);
      failsafeTimer = setTimeout(() => {
        for (const target of document.querySelectorAll('.hd-reveal-target:not(.is-revealed)')) {
          if (target.getBoundingClientRect().top < window.innerHeight) target.classList.add('is-revealed');
        }
      }, 1500);
    };
    if (revealObserver) {
      window.addEventListener('scroll', armFailsafe, { passive: true });
      document.addEventListener('visibilitychange', armFailsafe);
    }

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          scan(node);
          if (node instanceof Element && node.matches(ITEM_SELECTOR) && node.closest(SECTION_SELECTOR)) {
            node.dataset.hdReveal = 'done';
            node.classList.add('hd-reveal-target', 'is-revealed');
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    // Document pages: turn "MADDE ..." lines into numbered section headings with a sticky contents list
    const docMain = document.querySelector("main[data-template='page']");
    const docBody = docMain?.querySelector('.section-content-wrapper rte-formatter');
    if (docBody && !docBody.closest('.hd-doc')) {
      const pageTitle = docMain.querySelector('h1')?.textContent.trim().toLocaleLowerCase('tr');
      for (const h of docBody.querySelectorAll('h1, h2')) {
        if (h.textContent.trim().toLocaleLowerCase('tr') === pageTitle) h.hidden = true;
      }

      const isHeading = (el) => /^\s*(\d+[.)-]?\s*)?madde\b/i.test(el.textContent);
      const candidates = [...docBody.querySelectorAll('p, h2, h3, h4, li')].filter((el) => {
        if (!isHeading(el) || el.textContent.trim().length > 90) return false;
        return ![...el.children].some((child) => /^(P|LI|OL|UL|H\d)$/.test(child.tagName) && isHeading(child));
      });

      // "MADDE ..." lines written inside a longer paragraph after a <br>: split them out into their own element
      const walker = document.createTreeWalker(docBody, NodeFilter.SHOW_TEXT);
      const inlineNodes = [];
      while (walker.nextNode()) {
        const node = walker.currentNode;
        const block = node.parentElement.closest('p, li, h2, h3, h4');
        if (!block || candidates.includes(block) || !isHeading({ textContent: node.textContent })) continue;
        if (block.textContent.trim() === node.textContent.trim()) continue;
        inlineNodes.push(node);
      }
      for (const node of inlineNodes) {
        const span = document.createElement('span');
        span.style.display = 'flex';
        const prev = node.previousSibling;
        if (prev && prev.nodeName === 'BR') prev.remove();
        node.replaceWith(span);
        span.append(node);
        const next = span.nextSibling;
        if (next && next.nodeName === 'BR') next.remove();
        candidates.push(span);
      }
      candidates.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));

      const headings = [];
      for (const el of candidates) {
        const target = el.tagName === 'P' && el.parentElement.tagName === 'LI' && el.parentElement.firstElementChild === el ? el.parentElement : el;
        const heading = target.tagName === 'LI' ? target.querySelector(':scope > p') || target : target;
        const number = headings.length + 1;
        const label = heading.textContent.replace(/^\s*(\d+[.)-]?\s*)?madde\s*[-–:.]?\s*/i, '').trim() || `Madde ${number}`;
        heading.classList.add('hd-doc__heading');
        heading.id = heading.id || `madde-${number}`;
        heading.textContent = '';
        const num = document.createElement('span');
        num.className = 'hd-doc__number';
        num.textContent = `MADDE ${number}`;
        heading.append(num, document.createTextNode(label.charAt(0) + label.slice(1).toLocaleLowerCase('tr')));
        if (target.tagName === 'LI') target.style.listStyle = 'none';
        headings.push({ id: heading.id, number, label: label.charAt(0) + label.slice(1).toLocaleLowerCase('tr'), el: heading });
      }

      const layout = document.createElement('div');
      layout.className = 'hd-doc' + (headings.length >= 3 ? ' hd-doc--toc' : '');
      docBody.parentElement.insertBefore(layout, docBody);
      if (headings.length >= 3) {
        const toc = document.createElement('nav');
        toc.className = 'hd-doc__toc';
        toc.setAttribute('aria-label', 'İçindekiler');
        toc.innerHTML = '<p class="hd-doc__toc-title">İçindekiler</p><ol></ol>';
        const list = toc.querySelector('ol');
        for (const h of headings) {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = `#${h.id}`;
          a.innerHTML = `<span>${String(h.number).padStart(2, '0')}</span>`;
          a.append(document.createTextNode(h.label));
          li.append(a);
          list.append(li);
        }
        layout.append(toc);
        if ('IntersectionObserver' in window) {
          const links = new Map([...toc.querySelectorAll('a')].map((a) => [a.hash.slice(1), a]));
          const observer = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                if (!entry.isIntersecting) continue;
                for (const a of links.values()) a.classList.remove('is-active');
                links.get(entry.target.id)?.classList.add('is-active');
              }
            },
            { rootMargin: '-20% 0px -70% 0px' }
          );
          for (const h of headings) observer.observe(h.el);
        }
      }
      docBody.classList.add('hd-doc__body');
      layout.append(docBody);

      // Page title sits right above the first article, inside the document card
      const titleBlock = docMain.querySelector('.section-content-wrapper > .text-block:has(h1)');
      if (titleBlock) {
        titleBlock.classList.add('hd-doc__title');
        docBody.prepend(titleBlock);
      }

      // Contents list starts level with the first article heading
      const toc = layout.querySelector('.hd-doc__toc');
      if (toc && headings.length) {
        const alignToc = () => {
          if (titleBlock) {
            titleBlock.style.marginInlineStart = '0px';
            const shift = headings[0].el.getBoundingClientRect().left - titleBlock.querySelector('h1').getBoundingClientRect().left;
            titleBlock.style.marginInlineStart = `${Math.max(0, Math.round(shift))}px`;
          }
          toc.style.marginTop = '0px';
          if (!window.matchMedia('(min-width: 990px)').matches) return;
          const offset = headings[0].el.getBoundingClientRect().top - toc.getBoundingClientRect().top;
          toc.style.marginTop = `${Math.max(0, Math.round(offset))}px`;
        };
        alignToc();
        window.addEventListener('resize', alignToc, { passive: true });
        document.fonts?.ready.then(alignToc);
      }
    }
    // Carousel scroll indicator: thumb width shows visible share, position shows progress
    const initScrollbar = (carousel) => {
      if (carousel.dataset.hdScrollbar) return;
      const slides = carousel.querySelector('slideshow-slides');
      if (!slides) return;
      carousel.dataset.hdScrollbar = 'true';
      const bar = document.createElement('div');
      bar.className = 'hd-scrollbar';
      bar.setAttribute('aria-hidden', 'true');
      const thumb = document.createElement('div');
      thumb.className = 'hd-scrollbar__thumb';
      bar.append(thumb);
      carousel.append(bar);
      const update = () => {
        const max = slides.scrollWidth - slides.clientWidth;
        bar.hidden = max <= 4;
        if (max <= 4) return;
        const ratio = slides.clientWidth / slides.scrollWidth;
        thumb.style.width = `${ratio * 100}%`;
        thumb.style.left = `${(Math.abs(slides.scrollLeft) / max) * (1 - ratio) * 100}%`;
      };
      slides.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(slides);
      update();
    };
    document.querySelectorAll('.resource-list__carousel:not(.resource-list__carousel .resource-list__carousel)').forEach(initScrollbar);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hd-floating-actions"] && !Shopify.designMode) return;
  try {
    (window.hdPageReady || Promise.resolve()).then(() => {
    const button = document.querySelector('[data-hd-back-to-top]');
    if (!button) return;

    const toggle = () => {
      button.hidden = window.scrollY < window.innerHeight * 1.2;
    };

    button.addEventListener('click', () => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      document.querySelector('#MainContent')?.focus?.({ preventScroll: true });
    });

    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  });
  } catch(e) { console.error(e); }
})();

})();
